import React, { FC, useCallback, useState } from 'react';
import { InputGroup } from 'reactstrap';
import { Option, OptionDataValue } from '../../../shared/options';
import { PhoneInput } from '../PhoneInput';

interface OptionTextProps {
  readonly option: Option;
  readonly disabled?: boolean;
  readonly defaultValue?: OptionDataValue;
  readonly onChange?: (id: number, option: OptionDataValue) => void;
}

export const OptionPhoneComponent: FC<OptionTextProps> = ({
  disabled,
  option,
  defaultValue,
  onChange,
}) => {
  const [phoneVal, setPhoneVal] = useState<string | null>((defaultValue as string | null) ?? null);

  const onPhoneChange = useCallback(
    (value: string | null) => {
      onChange?.(option.id, value);
      setPhoneVal(value);
    },
    [onChange, option.id],
  );

  return (
    <InputGroup>
      <PhoneInput disabled={disabled} id="phone" onChange={onPhoneChange} value={phoneVal} />
    </InputGroup>
  );
};
